import React, { Component } from "react";

class BudgetTable extends Component {
  render() {
    return (
      <div style={{ overflowX: "auto", margin: "0px auto" }}>
        <table
          className="table table-bordered table-hover table-sm"
          style={{
            align: "center",
            margin: "auto",
            padding: "10px",
            overflowY: "auto",
            display: "block",
            height: "500px",
          }}
        >
          <thead>
            <tr style={{ background: "#2fa9e9" }}>
              <th
                rowSpan="2"
                style={{ verticalAlign: "middle", textAlign: "center" }}
              >
                Item Description
              </th>
              <th
                scope="col"
                colSpan={this.props.data["header"].length}
                style={{ textAlign: "center" }}
              >
                Financial Yearwise Budget(in Lakh Rs.)
              </th>
              <th
                rowSpan="2"
                style={{ verticalAlign: "middle", textAlign: "center" }}
              >
                Total
              </th>
            </tr>
            <tr style={{ background: "#2fa9e9" }}>
              {this.props.data["header"].map((key) => (
                <th key={key} scope="col">
                  {key}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Object.keys(this.props.data["rows"]).map((item, key) => (
              <tr key={key}>
                {this.props.data["rows"][item].map((item1, key1) =>
                  this.props.data["rows"][item].indexOf(item1) === 0 ? (
                    <td key={key1} style={{ textAlign: "left" }}>
                      {item1}
                    </td>
                  ) : (
                    <td key={key1} style={{ textAlign: "right" }}>
                      {item1}
                    </td>
                  )
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default BudgetTable;
